/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { CoolingTower } from "./modelCoolingTower";

class ControllerCoolingTower extends ControllerModel {
  constructor() {
    super("ControllerCoolingTower");

    this.setNewNode = (callback) => {
      let coolingTower = new CoolingTower();
      coolingTower.decorate(callback);

      this.addNode(coolingTower);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let coolingTower = new CoolingTower();
      coolingTower.copyFrom(node);
      coolingTower.decorate(callback);
      this.addNode(coolingTower);
    };

    this.getProperties = async (node) => {
      let n = new CoolingTower();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new CoolingTower();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerCoolingTower };
